export default __webpack_public_path__ + "static/media/support-experts-diversification.72a78586.svg";